export const district_data_school = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": "node/1489545888",
            "properties": {
                "amenity": "school",
                "name": "Shree Mahankali Secondary School",
                "id": "node/1489545888"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.5211945,
                    27.7201366
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2287639330",
            "properties": {
                "amenity": "school",
                "name": "Vidyadayini School",
                "id": "node/2287639330"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3765911,
                    27.673463
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2513634073",
            "properties": {
                "amenity": "school",
                "name": "Manohara Secondary School",
                "operator": "Nepal Government",
                "id": "node/2513634073"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4095133,
                    27.7056732
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/3136185727",
            "properties": {
                "amenity": "school",
                "name": "bright vision education center",
                "id": "node/3136185727"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3903629,
                    27.6901282
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4235529890",
            "properties": {
                "amenity": "school",
                "email": "seducon@hotmail.com",
                "name": "SEDUCON Pvt. Ltd. ",
                "phone": "+97716617093",
                "website": "https://seducon.webs.com/",
                "id": "node/4235529890"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4216874,
                    27.6729718
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4324876877",
            "properties": {
                "amenity": "school",
                "name": "Nepal Army School",
                "id": "node/4324876877"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.5190864,
                    27.7082422
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4324888421",
            "properties": {
                "amenity": "school",
                "name": "Shree Kalika Secondary School",
                "id": "node/4324888421"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4873336,
                    27.7108191
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4373340694",
            "properties": {
                "amenity": "school",
                "name": "Global pathshala",
                "opening_hours": "Su-Fr 08:30-16:30",
                "phone": "016638533",
                "id": "node/4373340694"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3686723,
                    27.6725237
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4550354490",
            "properties": {
                "addr:postcode": "44800",
                "addr:street": "Adarsha",
                "amenity": "school",
                "email": "info@vhsbhaktapur.org",
                "name:en": "VHS Bhaktapur",
                "opening_hours": "Mo-Fr 06:00-18:00",
                "phone": "016611283",
                "website": "http://www.vhsbhaktapur.org",
                "id": "node/4550354490"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4328767,
                    27.6678538
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4565333189",
            "properties": {
                "addr:postcode": "44800",
                "amenity": "school",
                "name:en": "Khwopa College of Engineering",
                "operator": "Bhaktapur Municipality",
                "id": "node/4565333189"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4390675,
                    27.6707947
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4565345589",
            "properties": {
                "addr:postcode": "44800",
                "amenity": "school",
                "name:en": "Bal Vikash Secondary School",
                "phone": "+9775122333",
                "id": "node/4565345589"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4422666,
                    27.6705503
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4742463425",
            "properties": {
                "amenity": "school",
                "name": "Shree Kulamaya Bhagwati School",
                "id": "node/4742463425"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3932983,
                    27.637829
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5153025022",
            "properties": {
                "amenity": "school",
                "name:en": "Saraswoti Secondary School",
                "id": "node/5153025022"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4908454,
                    27.6910272
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5270088722",
            "properties": {
                "addr:street": "Chonga Ganesh Road",
                "amenity": "school",
                "name:en": "Unique international English school",
                "id": "node/5270088722"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4040224,
                    27.6683218
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5479582621",
            "properties": {
                "addr:housenumber": "11",
                "addr:postcode": "12345",
                "addr:street": "BHAKTAPUR NALA ROAD(GANESHMAN MARGA)",
                "amenity": "school",
                "name:en": "Aarakshan national school",
                "opening_hours": "Su-Fr 00:00-24:00",
                "phone": "9841243750",
                "id": "node/5479582621"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.477628,
                    27.6788266
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5479582622",
            "properties": {
                "addr:housenumber": "11",
                "addr:postcode": "1234",
                "addr:street": "sudal bus park",
                "amenity": "school",
                "name:en": "Aarakshan national school",
                "opening_hours": "Su-Fr 00:00-24:00",
                "phone": "9841243750",
                "id": "node/5479582622"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4776936,
                    27.6787758
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5498199126",
            "properties": {
                "amenity": "school",
                "name": "बासु माध्यमिक विद्यालय (Basu secondary school)",
                "name:en": "बासु माध्यमिक विद्यालय (Basu secondary school)",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/5498199126"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4292246,
                    27.6783129
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5498199127",
            "properties": {
                "addr:street": "chyamasingh",
                "amenity": "school",
                "email": "infobagisworischool@gmail.com",
                "name": "Bagiswori Secondary School",
                "name:en": "बागीश्वरी माध्यमिक विद्यालय (Bagiswori Secondary School)",
                "phone": "6610270",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/5498199127"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4387743,
                    27.6730703
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5549773260",
            "properties": {
                "addr:country": "NP",
                "addr:place": "Jalkhu",
                "addr:street": "Jalkhu Marga",
                "amenity": "school",
                "name": "Pranodaya Primary School",
                "opening_hours": "10:00-16:00",
                "operator": "Public",
                "id": "node/5549773260"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3882594,
                    27.6793709
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064240605",
            "properties": {
                "amenity": "school",
                "name": "Sano Thimi Technical chool",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/6064240605"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3725551,
                    27.6808686
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6419160386",
            "properties": {
                "addr:postcode": "44811",
                "addr:street": "Gankhu _ bode",
                "amenity": "school",
                "name:en": "Everest Public Academy",
                "opening_hours": "Su-Fr 10:00-17:00",
                "id": "node/6419160386"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.396747,
                    27.6886141
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6497936382",
            "properties": {
                "amenity": "school",
                "name": "Dolgiri Higher Secondary school",
                "id": "node/6497936382"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4268248,
                    27.7156841
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6499238747",
            "properties": {
                "amenity": "school",
                "name": "Champak Vidyapith",
                "id": "node/6499238747"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.430116,
                    27.7170348
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6499238748",
            "properties": {
                "amenity": "school",
                "name": "Champak Vidyapith",
                "id": "node/6499238748"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4298666,
                    27.7172746
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/7551860486",
            "properties": {
                "addr:street": "Shyama Shyama Dham",
                "amenity": "school",
                "email": "gomapokhrel20@gmail.com",
                "name:en": "IRIS florets Bhaktapur Montessori",
                "opening_hours": "Su-Fr 09:00-17:00",
                "phone": "016636637",
                "id": "node/7551860486"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.398821,
                    27.6753435
                ]
            }
        }
    ]
}
